import { Container } from "components";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useToaster } from "hooks";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "services/api";
import * as Yup from "yup";

const initialValues = {
  name: "",
  status: "Active",
};

const validationSchema = Yup.object({
  name: Yup.string().required("Required"),
  status: Yup.string().required("Required"),
});

export const AddCity = () => {
  const navigate = useNavigate();
  const { setSuccessToaster, setErrorToaster } = useToaster();

  const handleSubmit = async (values) => {
    try {
      const response = await api.post("/cities", values);
      if (response?.status === 201 || response?.status === 200) {
        setSuccessToaster(response?.data?.message || "City added successfully");
        navigate("/cities");
      }
    } catch (error) {
      console.log("handleSubmit Error:", error);
      setErrorToaster(error?.response?.data?.message || "Failed to add city");
    }
  };

  return (
    <Container>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/cities">Cities</Link>
              </li>
              <li className="breadcrumb-item active">Add city</li>
            </ol>
          </nav>
          <div className="row">
            <div className="col-12">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ values, errors }) => {
                  return (
                    <Form>
                      <div className="card mb-4">
                        <h5 className="card-header">Add city</h5>
                        <hr className="my-0" />
                        <div className="card-body">
                          <div className="row mb-3">
                            <div className="col-md-6 col-12">
                              <label className="form-label">
                                Name <span className="invalid-form">*</span>
                              </label>
                              <Field
                                type="text"
                                className="form-control"
                                placeholder="Name"
                                name="name"
                              />
                              <ErrorMessage
                                name="name"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                            <div className="col-md-6 col-12">
                              <label className="form-label">
                                Status <span className="invalid-form">*</span>
                              </label>
                              <Field
                                as="select"
                                className="form-select"
                                name="status"
                              >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                              </Field>
                              <ErrorMessage
                                name="status"
                                component="div"
                                className="invalid-form"
                              />
                            </div>
                          </div>
                          <button
                            className="btn btn-primary d-grid w-100"
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

